import { image } from '../../../design-system'

export const BALogo = image({ url: require('./BA.png') })
export const CWULogo = image({
  url: require('./cwu logo white.png'),
})
export const CommonwealthLogo = image({
  url: require('./commonwealth.png'),
})
export const DCLogo = image({
  url: require('./dc.png'),
})
export const GJNLogo = image({ url: require('./GJN.png') })
export const MomentumLogo = image({
  url: require('./Momentum---red-on-white.png'),
})
export const NMLogo = image({ url: require('./NM.png') })
export const AutonomyLogo = image({
  url: require('./autonomy.png'),
  transform: 'scale(0.7)',
})
export const IWGBLogo = image({ url: require('./iwgb.png') })
export const NNULogo = image({ url: require('./nnu.png') })
export const PlutoLogo = image({ url: require('./Pluto.png') })
export const RosaLogo = image({
  url: require('./Rosa_Luxemburg_Foundation_logo.svg.png'),
})
export const TransformLogo = image({
  url: require('./transform_logo_2016.png'),
})
export const VersoLogo = image({ url: require('./Verso.png') })
export const WOWLogo = image({ url: require('./WOW.png') })
